// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.housing-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9000;
  display: flex;
  flex-direction: column;
  width: min(440px, 94vw);
  padding: 20px 20px 16px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: -18px 0 50px rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(6px);
  animation: housing-in 0.16s ease-out;
}
.housing-drawer * {
  box-sizing: border-box;
}
.housing-drawer h2, .housing-drawer h3, .housing-drawer h4, .housing-drawer p, .housing-drawer ul {
  margin: 0;
  padding: 0;
}
.housing-drawer ul {
  list-style: none;
}

@keyframes housing-in {
  from {
    opacity: 0;
    transform: translateX(14px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .housing-drawer {
    animation: none;
  }
}
.housing-drawer__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
}

.housing-drawer__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.1;
}

.housing-drawer__lead {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.45;
  color: #aeaba2;
  max-width: 34ch;
}

.housing-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.housing-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.housing-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.housing-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.housing-btn--primary {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.housing-btn--primary:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.housing-btn--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.housing-btn--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.housing-btn--quiet {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.housing-btn--quiet:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.housing-btn--sm {
  padding: 5px 10px;
  font-size: 13px;
}

.housing-field {
  width: 100%;
  padding: 9px 11px;
  font-family: inherit;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
}
.housing-field:focus {
  outline: none;
  border-color: var(--gold-main);
}
.housing-field::placeholder {
  color: #8d8a82;
  font-family: inherit;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.housing-field--inline {
  padding: 6px 9px;
}

.housing-label {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
}

.housing-hint {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}

.housing-empty {
  padding: 14px 0;
  font-size: 14px;
  color: #8d8a82;
}

.housing-houses {
  display: flex;
  gap: 4px;
  padding: 3px;
  margin-bottom: 14px;
  overflow-x: auto;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  scrollbar-width: none;
}
.housing-houses::-webkit-scrollbar {
  display: none;
}

.housing-houses__item {
  flex: 1 1 0;
  min-width: 0;
  padding: 7px 10px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
}
.housing-houses__item:hover {
  color: #ebe8e1;
}
.housing-houses__item:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.housing-houses__item--active {
  color: #14100a;
  background: var(--gold-main);
}
.housing-houses__item--active:hover {
  color: #14100a;
}

.housing-house {
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}

.housing-house__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.housing-house__name {
  min-width: 0;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.housing-house__state {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.45;
  color: #aeaba2;
}

.housing-tabs {
  display: flex;
  gap: 2px;
  margin-top: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.housing-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 12px;
  margin-bottom: -1px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}
.housing-tab:hover {
  color: #ebe8e1;
}
.housing-tab:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.housing-tab--active {
  color: var(--gold-light);
  border-bottom-color: var(--gold-main);
}

.housing-tab__count {
  min-width: 20px;
  padding: 1px 6px;
  font-size: 12px;
  text-align: center;
  color: #aeaba2;
  background: rgba(255, 255, 255, 0.09);
  border-radius: 10px;
}

.housing-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 2px 8px 0;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}
.housing-body::-webkit-scrollbar {
  width: 6px;
}
.housing-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.housing-section {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 17px;
}

.housing-section__meta {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 13px;
  color: #8d8a82;
}

.housing-list {
  display: flex;
  flex-direction: column;
}

.housing-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.housing-row__name {
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.housing-row__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.housing-chest {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.housing-chest .housing-row {
  border-top: 0;
}

.housing-access {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 0 14px 12px;
  margin-bottom: 6px;
  border-left: 2px solid var(--gold-dark);
}

.housing-check {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #aeaba2;
  cursor: pointer;
}
.housing-check input {
  accent-color: var(--gold-main);
  width: 16px;
  height: 16px;
}

.housing-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
}

.housing-form__row {
  display: flex;
  gap: 8px;
}

.housing-form__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}

.housing-journal {
  display: flex;
  flex-direction: column;
}

.housing-journal__row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px;
  padding: 9px 0;
  font-size: 14px;
  line-height: 1.4;
  color: #aeaba2;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.housing-journal__date {
  font-size: 13px;
  color: #8d8a82;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/HousingManage/HousingManage.scss"],"names":[],"mappings":"AAeA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yDAAA;EACA,cAjBK;EAkBL,kCAtBI;EAuBJ,+CAAA;EACA,4CAAA;EACA,0BAAA;EACA,oCAAA;AAdF;AAgBE;EAAI,sBAAA;AAbN;AAcE;EAAoB,SAAA;EAAW,UAAA;AAVjC;AAWE;EAAK,gBAAA;AARP;;AAWA;EACE;IAAO,UAAA;IAAY,2BAAA;EANnB;EAOA;IAAO,UAAA;IAAY,wBAAA;EAHnB;AACF;AAKA;EACE;IAAkB,eAAA;EAFlB;AACF;AAIA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;AAFF;;AAKA;EACE,kDAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAxDO;EAyDP,eAAA;AAFF;;AASA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cA1EK;EA2EL,qCAAA;EACA,0CAAA;EACA,kBAzEO;EA0EP,eAAA;EACA,kFAAA;AANF;AAQE;EAAyB,qCAAA;EAAuC,8BAAA;AAJlE;AAKE;EAAa,YAAA;EAAc,mBAAA;AAD7B;AAEE;EAAkB,oCAAA;EAAsC,mBAAA;AAE1D;AAAE;EACE,cAAA;EACA,4BAAA;EACA,8BAAA;AAEJ;AAAI;EAAyB,6BAAA;EAA+B,+BAAA;AAI5D;AADE;EACE,cA3FK;EA4FL,uBAAA;EACA,uCAAA;AAGJ;AADI;EAAyB,qCAAA;EAAuC,qBA/F3D;AAoGT;AAFE;EACE,cApGK;EAqGL,uBAAA;EACA,yBAAA;AAIJ;AAFI;EAAyB,cA1GtB;EA0GoC,qCAAA;EAAuC,yBAAA;AAOlF;AAJE;EAAQ,iBAAA;EAAmB,eAAA;AAQ7B;;AALA;EACE,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,cArHK;EAsHL,+BAAA;EACA,0CAAA;EACA,kBApHO;AA4HT;AANE;EAAU,aAAA;EAAe,8BAAA;AAU3B;AATE;EAAiB,cAzHV;EAyH0B,oBAAA;EAAsB,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AAgBvG;AAfE;EAAY,gBAAA;AAkBd;;AAfA;EACE,eAAA;EACA,gBAAA;EACA,cAjIO;AAmJT;;AAfA;EACE,eAAA;EACA,gBAAA;EACA,cAtIO;AAwJT;;AAfA;EACE,eAAA;EACA,eAAA;EACA,cA5IO;AA8JT;;AAXA;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,2CAAA;EACA,kBAzJO;EA0JP,qBAAA;AAcF;AAZE;EAAuB,aAAA;AAezB;;AAZA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cA5KO;EA6KP,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAeF;AAbE;EAAU,cAnLL;AAmMP;AAfE;EAAkB,oCAAA;EAAsC,mBAAA;AAmB1D;AAjBE;EAAY,cAAA;EAAgB,4BAAA;AAqB9B;AArB4D;EAAU,cAAA;AAwBtE;;AArBA;EACE,kBAAA;EACA,qCA9LW;EA+LX,2CAAA;EACA,kBAzLO;AAiNT;;AArBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAwBF;;AArBA;EACE,YAAA;EACA,kDAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAwBF;;AArBA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAnNO;AA2OT;;AArBA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,kDAAA;AAwBF;;AArBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAtOO;EAuOP,uBAAA;EACA,SAAA;EACA,oCAAA;EACA,eAAA;AAwBF;AAtBE;EAAU,cA7OL;AAsQP;AAxBE;EAAkB,oCAAA;EAAsC,oBAAA;AA4B1D;AA3BE;EAAY,wBAAA;EAA0B,qCAAA;AA+BxC;;AA5BA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAtPO;EAuPP,qCAAA;EACA,mBAAA;AA+BF;;AAxBA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qDAAA;AA2BF;AAzBE;EAAuB,UAAA;AA4BzB;AA3BE;EAA6B,oCAAA;EAAsC,kBAAA;AA+BrE;;AA5BA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,kDAAA;EACA,gBAAA;EACA,eAAA;AA+BF;;AA5BA;EACE,yDAAA;EACA,eAAA;EACA,cAxRO;AAuTT;;AA5BA;EAAgB,aAAA;EAAe,sBAAA;AAiC/B;;AA/BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,+CAAA;AAkCF;;AA/BA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAkCF;;AA/BA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;AAkCF;;AA/BA;EAAiB,+CAAA;AAmCjB;;AAlCA;EAA8B,aAAA;AAsC9B;;AApCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,uCAAA;AAuCF;;AApCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAtUO;EAuUP,eAAA;AAuCF;AArCE;EAAQ,8BAAA;EAAgC,WAAA;EAAa,YAAA;AA0CvD;;AAvCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AA0CF;;AAvCA;EACE,aAAA;EACA,QAAA;AA0CF;;AAvCA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;AA0CF;;AAvCA;EAAmB,aAAA;EAAe,sBAAA;AA4ClC;;AA1CA;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAvWO;EAwWP,+CAAA;AA6CF;;AA1CA;EACE,eAAA;EACA,cA5WO;EA6WP,mBAAA;AA6CF","sourcesContent":["// Housing management drawer. Docked to the right edge of the screen (same side\n// as the ALT menu) so the door or the room you are looking at stays visible.\n// Same look as the escape menu: ink panel, accent from the global palette\n// tokens, one corner radius, DIN for text and Marcellus for titles.\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$radius: 6px;\n\n.housing-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9000;\n  display: flex;\n  flex-direction: column;\n  width: min(440px, 94vw);\n  padding: 20px 20px 16px;\n  font-family: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n  color: $text;\n  background: $ink;\n  border-left: 1px solid $line-strong;\n  box-shadow: -18px 0 50px rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(6px);\n  animation: housing-in 0.16s ease-out;\n\n  * { box-sizing: border-box; }\n  h2, h3, h4, p, ul { margin: 0; padding: 0; }\n  ul { list-style: none; }\n}\n\n@keyframes housing-in {\n  from { opacity: 0; transform: translateX(14px); }\n  to   { opacity: 1; transform: translateX(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .housing-drawer { animation: none; }\n}\n\n.housing-drawer__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 14px;\n}\n\n.housing-drawer__title {\n  font-family: 'Marcellus', 'Cinzel', Georgia, serif;\n  font-weight: 400;\n  font-size: 26px;\n  line-height: 1.1;\n}\n\n.housing-drawer__lead {\n  margin-top: 6px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: $text-2;\n  max-width: 34ch;\n}\n\n// ---------------------------------------------------------------------------\n// Controls\n// ---------------------------------------------------------------------------\n\n.housing-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 14px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n\n  &--primary {\n    color: #14100a;\n    background: var(--gold-main);\n    border-color: var(--gold-main);\n\n    &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n  }\n\n  &--danger {\n    color: $danger;\n    background: transparent;\n    border-color: rgba(217, 120, 109, 0.45);\n\n    &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n  }\n\n  &--quiet {\n    color: $text-3;\n    background: transparent;\n    border-color: transparent;\n\n    &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n  }\n\n  &--sm { padding: 5px 10px; font-size: 13px; }\n}\n\n.housing-field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: inherit;\n  font-size: 14px;\n  color: $text;\n  background: rgba(0, 0, 0, 0.35);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: inherit; text-transform: none; letter-spacing: normal; opacity: 1; }\n  &--inline { padding: 6px 9px; }\n}\n\n.housing-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n.housing-hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n.housing-empty {\n  padding: 14px 0;\n  font-size: 14px;\n  color: $text-3;\n}\n\n// ---------------------------------------------------------------------------\n// House selector, house header, tabs\n// ---------------------------------------------------------------------------\n\n.housing-houses {\n  display: flex;\n  gap: 4px;\n  padding: 3px;\n  margin-bottom: 14px;\n  overflow-x: auto;\n  background: rgba(0, 0, 0, 0.35);\n  border: 1px solid $line;\n  border-radius: $radius;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar { display: none; }\n}\n\n.housing-houses__item {\n  flex: 1 1 0;\n  min-width: 0;\n  padding: 7px 10px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-radius: 4px;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n\n  &--active { color: #14100a; background: var(--gold-main); &:hover { color: #14100a; } }\n}\n\n.housing-house {\n  padding: 14px 16px;\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n.housing-house__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.housing-house__name {\n  min-width: 0;\n  font-family: 'Marcellus', 'Cinzel', Georgia, serif;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n}\n\n.housing-house__state {\n  margin-top: 8px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: $text-2;\n}\n\n.housing-tabs {\n  display: flex;\n  gap: 2px;\n  margin-top: 14px;\n  border-bottom: 1px solid $line;\n}\n\n.housing-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n  &--active { color: var(--gold-light); border-bottom-color: var(--gold-main); }\n}\n\n.housing-tab__count {\n  min-width: 20px;\n  padding: 1px 6px;\n  font-size: 12px;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n// ---------------------------------------------------------------------------\n// Body\n// ---------------------------------------------------------------------------\n\n.housing-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 2px 8px 0;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n.housing-section {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 8px;\n  font-family: 'Marcellus', 'Cinzel', Georgia, serif;\n  font-weight: 400;\n  font-size: 17px;\n}\n\n.housing-section__meta {\n  font-family: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n  font-size: 13px;\n  color: $text-3;\n}\n\n.housing-list { display: flex; flex-direction: column; }\n\n.housing-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 9px 0;\n  border-top: 1px solid $line;\n}\n\n.housing-row__name {\n  min-width: 0;\n  font-size: 15px;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.housing-row__actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n.housing-chest { border-top: 1px solid $line; }\n.housing-chest .housing-row { border-top: 0; }\n\n.housing-access {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 4px 0 14px 12px;\n  margin-bottom: 6px;\n  border-left: 2px solid var(--gold-dark);\n}\n\n.housing-check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: $text-2;\n  cursor: pointer;\n\n  input { accent-color: var(--gold-main); width: 16px; height: 16px; }\n}\n\n.housing-form {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.housing-form__row {\n  display: flex;\n  gap: 8px;\n}\n\n.housing-form__actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 4px;\n}\n\n.housing-journal { display: flex; flex-direction: column; }\n\n.housing-journal__row {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 12px;\n  padding: 9px 0;\n  font-size: 14px;\n  line-height: 1.4;\n  color: $text-2;\n  border-top: 1px solid $line;\n}\n\n.housing-journal__date {\n  font-size: 13px;\n  color: $text-3;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
